import React, { useEffect, useState } from "react";
import styles from "./MemoryChart.module.css";
import { getUser } from "../../utils/storage";

const MemoryChart = () => {
  const [scores, setScores] = useState({
    sequence: 0,
    visual: 0,
    delay: 0
  });

  const loadData = () => {
    const user = getUser();

    setScores({
      sequence: user.scores?.sequence || 0,
      visual: user.scores?.visual || 0,
      delay: user.scores?.delay || 0
    });
  };

  useEffect(() => {
    loadData();

    window.addEventListener("ml_update", loadData);
    return () => window.removeEventListener("ml_update", loadData);
  }, []);

  const total = scores.sequence + scores.visual + scores.delay;

  const getPercent = (value) => {
    if (total === 0) return 0;
    return (value / total) * 100;
  };

  const data = [
    { label: "Sequência", value: scores.sequence, color: "#5c6bc0" },
    { label: "Visual", value: scores.visual, color: "#26a69a" },
    { label: "Retenção", value: scores.delay, color: "#ef5350" }
  ];

  const active = data.filter(d => d.value > 0);

  // 🔥 CASO ESPECIAL: apenas 1 tipo jogado
  if (active.length === 1 && total > 0) {
    return (
      <div className={styles.container}>
        <h3>📊 Distribuição de Memória</h3>

        <svg viewBox="0 0 300 300" className={styles.chart}>
          <circle
            cx="150"
            cy="150"
            r="100"
            fill={active[0].color}
          />

          <text
            x="150"
            y="150"
            textAnchor="middle"
            dominantBaseline="middle"
            className={styles.centerLabel}
          >
            100%
          </text>
        </svg>

        <div className={styles.legend}>
          <div className={styles.legendItem}>
            <span
              className={styles.dot}
              style={{ background: active[0].color }}
            />
            {active[0].label}
          </div>
        </div>
      </div>
    );
  }

  // 🔥 NORMAL (2 ou 3 tipos)
  let cumulative = 0;

  const getCoordinates = (percent) => {
    const angle = 2 * Math.PI * percent;
    return {
      x: 150 + 100 * Math.cos(angle),
      y: 150 + 100 * Math.sin(angle)
    };
  };

  const slices = data.map((item, index) => {
    const percent = getPercent(item.value) / 100;

    if (percent === 0) return null;

    const start = cumulative;
    cumulative += percent;
    const end = cumulative;

    const startCoord = getCoordinates(start);
    const endCoord = getCoordinates(end);

    const largeArc = percent > 0.5 ? 1 : 0;

    const pathData = `
      M 150 150
      L ${startCoord.x} ${startCoord.y}
      A 100 100 0 ${largeArc} 1 ${endCoord.x} ${endCoord.y}
      Z
    `;

    const mid = (start + end) / 2;

    const labelPos = {
      x: 150 + 130 * Math.cos(2 * Math.PI * mid),
      y: 150 + 130 * Math.sin(2 * Math.PI * mid)
    };

    return (
      <g key={index}>
        <path d={pathData} fill={item.color} />

        <text
          x={labelPos.x}
          y={labelPos.y}
          textAnchor="middle"
          className={styles.label}
        >
          {Math.round(getPercent(item.value))}%
        </text>
      </g>
    );
  });

  return (
    <div className={styles.container}>
      <h3>📊 Distribuição de Memória</h3>

      <svg viewBox="0 0 300 300" className={styles.chart}>
        {total === 0 ? (
          <text x="150" y="150" textAnchor="middle" className={styles.empty}>
            Sem dados
          </text>
        ) : (
          slices
        )}
      </svg>

      <div className={styles.legend}>
        {data.map((item, i) => (
          <div key={i} className={styles.legendItem}>
            <span
              className={styles.dot}
              style={{ background: item.color }}
            />
            {item.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MemoryChart;